<style lang="less">
.divider {
  display: inline-block;
  clear: both;
  background: #e8e8e8;
  margin: 24px 0;
}
.divider-horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
.divider-vertical {
  display: inline-block;
  width: 1px;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
  top: -0.06em;
}
</style>

<template>
  <div class="divider" :class="type == 'horizontal' ? 'divider-horizontal' : 'divider-vertical'" />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'horizontal'
    }
  }
}
</script>
